// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
// ** Axios Imports
import axios from 'axios'

export const setLoading = createAsyncThunk('appCorporatePayments/setLoading', async (loadingState) => ({ ...loadingState }))

export const getData = createAsyncThunk('appCorporatePayments/getData', async (params, { dispatch, getState }) => {
  dispatch(setLoading({ getData: true }))
  let response;

  if(params?.type === 0) {
    response = await axios.get('/CorporateTaxPayments/GetCorporateTaxReturnDues', {params})
  } else {
    response = await axios.get('/CorporateTaxPayments/GetCorporateTaxReturnPaymentHistory', {params})
  }
  dispatch(setLoading({getData: false}))
  return {
    params,
    data: response.data
  }
})

export const appCorporatePaymentsSlice = createSlice({
  name: 'appCorporatePayments',
  initialState: {
    data: [],
    totalRecords: 1,
    params: {},
    loadingState: { getData: false }
    // allData: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data.data.list
        state.totalRecords = action.payload.data.data.totalRecords
        state.params = action.payload.params
      })
      .addCase(setLoading.fulfilled, (state, action) => {
        state.loadingState = action.payload
      })
  }
})

export default appCorporatePaymentsSlice.reducer
